import type {
  QueryStringSerializer,
} from '@/scopes/common/infrastructure/query-strings/queryStringSerializer'
import { TokenInfo } from '@/scopes/checkout/groups/domain/types/api'
import defaultFetch from 'isomorphic-unfetch'

interface Dependencies {
  env: {
    NEXT_PUBLIC_BASE_URL: string
  }
  fetch: typeof defaultFetch
  queryStringSerializer: QueryStringSerializer
}

export function createQueueAPIClient(dependencies: Partial<Dependencies> = {}) {
  const {
    env = {
      NEXT_PUBLIC_BASE_URL: process.env.NEXT_PUBLIC_BASE_URL,
    },
    fetch = defaultFetch,
  } = dependencies as Dependencies

  async function createToken(): Promise<TokenInfo> {
    const response = await fetch(
      `${env.NEXT_PUBLIC_BASE_URL}/api/checkout-queue/gettoken`,
    )
    return await response.json()
  }

  return {
    createToken,
  }
}
